module.exports = __webpack_public_path__ + "img/hr-tree-01-e-leaves.08a56f21.png";